import { Catalog } from '@df/catalog/catalog.interfaces';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { ListingFilter } from '@df/catalog-ui/listing/listing';
import { NgInject } from '@df/ng/ng-inject';
import { TimeoutService } from '@df/ng/timeout.service';
import { EListingLabelOptionId, LocalProduct } from '../../../../model/product/product.decorator';
import { IResourceIndex } from '@df/catalog/resource';
import { IProductData, Product } from '@df/catalog/product/product';
export const IN_STOCK_FILTER_ID = 'in_stock';
export enum EStockOption {
    outOfStock,
    inStock
}
const outOfStockLabels = [EListingLabelOptionId.backSoon, EListingLabelOptionId.soldOut, EListingLabelOptionId.comingSoon];
export function isOutOfStock(product: LocalProduct<IProductData>) {
    const listingLabel = product.getListingLabel();
    return listingLabel ? outOfStockLabels.includes(listingLabel) : false;
}
@ListingFilter({
    filterType: 'stock'
})
export class FilterStock<T extends LocalProduct<IProductData>> extends FilterAttributeOption<T> {
    showCheckbox = true;
    @NgInject(TimeoutService)
    private timeoutService!: TimeoutService;
    /**
     * Temp lock for toggle
     */
    private locked = false;
    private indexCache: {
        [attributeValue: number]: { [modelId: number]: boolean };
    } = {};
    override get options() {
        return [
            {
                value: EStockOption.inStock,
                label: 'Hide out of stock'
            }
        ];
    }

    override getIndex(): IResourceIndex {
        if (!this.indexCache) {
            const index: IResourceIndex = {
                [EStockOption.inStock]: {},
                [EStockOption.outOfStock]: {}
            };
            this.listing.getSourceModels().forEach(product => {
                index[isOutOfStock(product) ? EStockOption.outOfStock : EStockOption.inStock][product.id] = true;
            });
            this.indexCache = index;
        }
        return this.indexCache;
    }
    /**
     * For some reason checkbox triggers doubled events
     * this is just to throttle it
     */
    override toggle(option): void {
        if (this.locked) {
            return;
        }
        this.locked = true;
        this.timeoutService.setTimeout(() => {
            this.locked = false;
        }, 200);
        super.toggle(option, true);
    }
    override getSelectedOptions(): Catalog.IAttributeOption[] {
        return this.options.filter(i => this.selection?.includes(i.value));
    }
}
